import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-customer-registeration',
  templateUrl: './customer-registeration.component.html',
  styleUrls: ['./customer-registeration.component.css']
})
export class CustomerRegisterationComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
